// extracted by mini-css-extract-plugin
module.exports = {"value":"styles_value__uS8hj","diff":"styles_diff__EuuHn","plus":"styles_plus__8dbs9","minus":"styles_minus__Ymofz"};